/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import { ServiceTemplateItems } from '../Features/ServiceTemplateEdit';
import GridItem from '../../components/Grid/GridItem';
import DeleteButton from '../../components/Buttons/DeleteButton';

type VirtualComponentSelectedPromotionType = {
    serviceTemplate: ServiceTemplateItems;
    deleteCallback(promotionId: number): void;
};

export const VirtualComponentSelectedPromotion: FunctionComponent<VirtualComponentSelectedPromotionType> = ({
    serviceTemplate,
    deleteCallback,
}): ReactElement => {
    const processItems = (item: { value: number; name: string }): ReactElement => {
        return (
            <GridContainer key={'promotion_' + item.name + item.value}>
                <GridItem xs={2}>
                    <DeleteButton callback={(): void => deleteCallback(item.value)} callbackParam={{}} tooltipTitle="prov:feature.delete_feature" />
                </GridItem>
                <GridItem xs={4}>{item.name}</GridItem>
            </GridContainer>
        );
    };
    return (
        <GridContainer>
            {serviceTemplate.promotions &&
                serviceTemplate.promotions.map((item, index) => {
                    return processItems(item);
                })}
        </GridContainer>
    );
};
